<script lang="ts">
    import { getDashboardCtx } from "../../state/dashboard.svelte";
    import { translate } from "@/utils/format";

    const store = getDashboardCtx();
</script>

<div class="referrals__stripe">
    <h3>
        {translate(
            "PARTNER_STRIPE_CONNECT_TITLE",
            "Stripe Connect",
        )}
    </h3>
    {#if !store.stripeAccountId}
        <p>
            {translate(
                "PARTNER_STRIPE_NOT_CONNECTED",
                "Aún no has conectado tu cuenta de Stripe.",
            )}
        </p>
    {:else if !store.stripeReady}
        <p class="warning">
            {translate(
                "PARTNER_STRIPE_PENDING",
                "Configura tu perfil de pagos con Stripe.",
            )}
        </p>
    {:else}
        <p class="success">
            {translate(
                "PARTNER_STRIPE_READY",
                "Tu cuenta de Stripe está lista.",
            )}
        </p>
    {/if}

    <div class="referrals__buttons">
        {#if !store.stripeAccountId}
            <button
                class="button --primary"
                onclick={store.createStripeAccount}
            >
                {translate(
                    "PARTNER_STRIPE_CREATE_ACCOUNT",
                    "Crear cuenta",
                )}
            </button>
        {/if}

        {#if store.stripeAccountId && !store.stripeReady}
            <button class="button" onclick={store.createAccountLink}>
                {translate(
                    "PARTNER_STRIPE_ONBOARDING",
                    "Completar perfil de Stripe",
                )}
            </button>
        {/if}

        {#if store.stripeAccountId && store.stripeReady}
            <button
                class="button --primary"
                onclick={store.goStripePanel}
            >
                {translate(
                    "PARTNER_GO_TO_STRIPE",
                    "Ir al panel de Stripe",
                )}
            </button>
        {/if}
    </div>
</div>
